(() => {
  'use strict';
  if (window.__ossLeagueClubFilterInstalled) return;
  window.__ossLeagueClubFilterInstalled = true;

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const clean = (value) => String(value == null ? '' : value).trim();
  const key = (value) => clean(value).toLocaleLowerCase('en');
  const controllers = new Set();

  const parseJson = (node) => {
    if (!node) return [];
    try {
      const data = JSON.parse(node.textContent);
      return Array.isArray(data) ? data : [];
    } catch (_) {
      return [];
    }
  };

  const initials = (name) => clean(name).split(/\s+/).filter(Boolean).slice(0, 3).map((part) => part[0]).join('').toUpperCase();

  const createFallback = (clubName) => {
    const fallback = document.createElement('span');
    fallback.className = 'oss-club-filter-button__fallback';
    fallback.textContent = initials(clubName);
    return fallback;
  };

  const productHandleFromCard = (card) => {
    const link = qs('.product-block__title-link[href*="/products/"]', card) || qs('a[href*="/products/"]', card);
    if (!link) return '';
    const match = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const readSelectionFromUrl = (validKeys) => {
    const url = new URL(window.location.href);
    const raw = clean(url.searchParams.get('oss_clubs'));
    if (!raw) return new Set();
    const selected = new Set();
    raw.split('|').map((item) => key(item)).forEach((clubKey) => {
      if (validKeys.has(clubKey)) selected.add(clubKey);
    });
    return selected;
  };

  const writeSelectionToUrl = (selected, clubsByKey) => {
    const url = new URL(window.location.href);
    if (selected.size) {
      const names = Array.from(selected).map((clubKey) => clubsByKey.get(clubKey)?.name).filter(Boolean);
      url.searchParams.set('oss_clubs', names.join('|'));
    } else {
      url.searchParams.delete('oss_clubs');
    }
    window.history.replaceState({}, '', url.toString());
  };

  const placeModule = (root) => {
    const results = qs('.cc-filters-results');
    if (!results || !results.parentNode) return null;
    const parent = results.parentNode;
    if (root.parentNode !== parent || parent.firstElementChild !== root) {
      parent.insertBefore(root, parent.firstChild);
    }
    root.hidden = false;
    return results;
  };

  const install = (root) => {
    if (!root || root.dataset.ossLeagueReady === '1') return;

    const results = placeModule(root);
    root.dataset.ossLeagueReady = '1';

    const filter = qs('[data-oss-league-club-filter]', root);
    const data = parseJson(qs('[data-oss-club-data]', root));
    if (!filter || !data.length) return;

    const handleToClub = new Map();
    const clubsByKey = new Map();

    data.forEach((entry) => {
      const club = clean(entry && entry.club);
      const handle = clean(entry && entry.handle);
      if (!club || !handle) return;
      const clubKey = key(club);
      handleToClub.set(handle, clubKey);
      if (!clubsByKey.has(clubKey)) clubsByKey.set(clubKey, { key: clubKey, name: club, logo: clean(entry.logo) });
      else if (!clubsByKey.get(clubKey).logo && clean(entry.logo)) clubsByKey.get(clubKey).logo = clean(entry.logo);
    });

    const clubs = Array.from(clubsByKey.values()).sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
    if (!clubs.length) return;

    const clubList = qs('[data-oss-club-list]', filter);
    const chipList = qs('[data-oss-club-chips]', filter);
    if (!clubList || !chipList) return;

    const validKeys = new Set(clubs.map((club) => club.key));
    const selected = readSelectionFromUrl(validKeys);
    const buttonByKey = new Map();

    clubs.forEach((club) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'oss-club-filter-button';
      button.dataset.clubKey = club.key;
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', `Filter by ${club.name}`);

      const crestWrap = document.createElement('span');
      crestWrap.className = 'oss-club-filter-button__crest-wrap';

      if (club.logo) {
        const img = document.createElement('img');
        img.className = 'oss-club-filter-button__crest';
        img.src = club.logo;
        img.alt = `${club.name} crest`;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.addEventListener('error', () => {
          img.remove();
          if (!qs('.oss-club-filter-button__fallback', crestWrap)) {
            crestWrap.appendChild(createFallback(club.name));
          }
        }, { once: true });
        crestWrap.appendChild(img);
      } else {
        crestWrap.appendChild(createFallback(club.name));
      }

      const name = document.createElement('span');
      name.className = 'oss-club-filter-button__name';
      name.textContent = club.name;
      button.append(crestWrap, name);
      clubList.appendChild(button);
      buttonByKey.set(club.key, button);
    });

    const initialPagination = results && (qs('.pagination', results) || qs('.pagination-row', results));
    const hasMultiplePages = !!initialPagination;

    const renderChips = () => {
      chipList.replaceChildren();
      clubs.forEach((club) => {
        if (!selected.has(club.key)) return;
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'oss-league-club-filter__chip';
        chip.dataset.clubKey = club.key;
        chip.setAttribute('aria-label', `Remove ${club.name} filter`);

        const label = document.createElement('span');
        label.textContent = club.name;

        const x = document.createElement('span');
        x.className = 'oss-league-club-filter__chip-x';
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';

        chip.append(label, x);
        chipList.appendChild(chip);
      });
    };

    const apply = () => {
      const currentResults = qs('.cc-filters-results');
      if (!currentResults) return;

      const cards = qsa('.product-block', currentResults);
      let visible = 0;

      cards.forEach((card) => {
        const handle = productHandleFromCard(card);
        const clubKey = handleToClub.get(handle) || '';
        const show = selected.size === 0 || (clubKey && selected.has(clubKey));
        card.hidden = !show;
        if (show) visible += 1;
      });

      buttonByKey.forEach((button, clubKey) => {
        const active = selected.has(clubKey);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      renderChips();

      const summary = qs('.cc-filters-results__summary', currentResults);
      if (summary) {
        if (!summary.dataset.ossClubOriginalSummary) summary.dataset.ossClubOriginalSummary = clean(summary.textContent);
        summary.textContent = selected.size > 0
          ? `${visible} ${visible === 1 ? 'product' : 'products'}`
          : summary.dataset.ossClubOriginalSummary;
      }

      let empty = qs('.oss-club-filter-empty', currentResults);
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'oss-club-filter-empty';
        empty.textContent = 'No products match the selected clubs.';
        const grid = qs('.grid-flex', currentResults);
        if (grid) currentResults.insertBefore(empty, grid);
        else currentResults.prepend(empty);
      }
      empty.hidden = !(selected.size > 0 && visible === 0);

      const pagination = qs('.pagination', currentResults) || qs('.pagination-row', currentResults);
      if (pagination) pagination.hidden = selected.size > 0;

      writeSelectionToUrl(selected, clubsByKey);
    };

    const maybeOpenLeagueView = () => {
      const url = new URL(window.location.href);
      if (!hasMultiplePages || url.searchParams.get('view') === 'league') return false;
      const names = Array.from(selected).map((clubKey) => clubsByKey.get(clubKey)?.name).filter(Boolean);
      if (!names.length) return false;
      url.searchParams.set('view', 'league');
      url.searchParams.set('oss_clubs', names.join('|'));
      window.location.assign(url.toString());
      return true;
    };

    clubList.addEventListener('click', (event) => {
      const button = event.target.closest('.oss-club-filter-button[data-club-key]');
      if (!button) return;
      const clubKey = button.dataset.clubKey;
      if (selected.has(clubKey)) selected.delete(clubKey);
      else selected.add(clubKey);
      if (!maybeOpenLeagueView()) apply();
    });

    chipList.addEventListener('click', (event) => {
      const chip = event.target.closest('.oss-league-club-filter__chip[data-club-key]');
      if (!chip) return;
      selected.delete(chip.dataset.clubKey);
      apply();
    });

    const controller = { root, apply };
    controllers.add(controller);
    if (!maybeOpenLeagueView()) apply();
  };

  const installAll = () => qsa('[data-oss-league-page-tools]').forEach(install);
  let mutationTimer = null;

  const mutationContainsProducts = (mutation) => {
    const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
    return nodes.some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches('.product-block, .cc-filters-results') || !!node.querySelector('.product-block, .cc-filters-results');
    });
  };

  const refresh = () => {
    installAll();
    controllers.forEach((controller) => {
      if (controller.root.isConnected) controller.apply();
      else controllers.delete(controller);
    });
  };

  const init = () => {
    installAll();
    new MutationObserver((mutations) => {
      if (!mutations.some(mutationContainsProducts)) return;
      window.clearTimeout(mutationTimer);
      mutationTimer = window.setTimeout(refresh, 80);
    }).observe(document.body, { subtree: true, childList: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
